import React, { useState, useEffect } from 'react';
import { auth } from '../config/Config'; // Firebase Auth
import Swal from 'sweetalert2';
import { useNavigate  } from 'react-router-dom';
import'./AdminLogin.css'

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') === 'true'); // Check local storage
  const navigate = useNavigate();

  useEffect(() => {
    // If localStorage does not have admin token, force logout
    if (localStorage.getItem('isAdmin') !== 'true') {
      setIsAdmin(false);
    }
  }, []);

  const handleAdminLogin = (e) => {
    e.preventDefault();

    auth.signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        const user = userCredential.user;

        if (user.uid === 'EMkWZuE0e1UvN8uS6YA9gmxZ0cu1') {
       
          localStorage.setItem('isAdmin', 'true');

          Swal.fire({
            position: "center",
            icon: "success",
            title: "Welcome Admin!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            setIsAdmin(true);
            navigate('/admin-dashboard');
          });
        } else {
          auth.signOut();
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Access Denied",
            text: "You are not an admin.",
            showConfirmButton: true
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Login Failed!",
          text: err.message,
          showConfirmButton: true
        });
      });
  };



  return (
    <div className='box'>

    <div className='box1' >
      <form className='box2' onSubmit={handleAdminLogin}>
        <input className='box6'
          type="email"
 
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          required
        />
        <input className='box6'
          type="password"
   
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          required
        />
        <button className='box4' type="submit">Admin Login</button>
      </form>
    </div>
    </div>
  );
}

export default AdminLogin;
